import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components';
import Navbar from './Navbar';

const Container = styled.div`
    width: 100vw;
    height: 90vh;
    display: flex;
    justify-content: center;
    align-items: center;
`
const NoFound = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`
const Figure = styled.div`
    
`
const Image = styled.img`
    width: 400px;
`
const Disc = styled.h1`
    margin-top: 0;
`
const Button = styled.button`
    background-color:#fff ;
    color: blue;
    border: 1px solid blue;
    padding: 10px 20px ;
    cursor: pointer;
&:hover{
    background-color: blue;
    color: #fff;

}
`
const NoPage = () => {
    return (
        <>
            <Navbar />
            <Container>
                <NoFound>
                    <Figure>
                        <Image src="https://img.freepik.com/free-vector/error-404-concept-landing-page_52683-12188.jpg?t=st=1653150504~exp=1653151104~hmac=a12f819588df22b07b426620b067226c128bbbe7e38762d2388e186fff506913&w=740" alt="" />
                    </Figure>
                    <Disc>OOPs! 404 error page not found</Disc>
                    <Link to="/"><Button >BACK TO HOME</Button></Link>
                </NoFound>
            </Container>
        </>
    )
}

export default NoPage;